import type { Page } from '@/app/common/starTrack/events/utils/starTrack.types.ts';

export const VOUCHER_INFO_CLICKED = 'VOUCHER_INFO_CLICKED';
export const VOUCHER_INFO_CLICKED_VERSION = '1.0';

export type VoucherInfoClickedPayload = {
  searchId: string;
  page: Page;
  productDetailKey?: string;
};

export type VoucherInfoClickedParams = {
  searchId: string;
};

export const createVoucherInfoClickedPayload = ({ searchId }: VoucherInfoClickedParams): VoucherInfoClickedPayload => ({
  searchId,
  page: 'RESULT_PAGE', // TODO: to be implemented when the event will be triggered in 'DETAILS_PAGE'
  productDetailKey: undefined, //  // TODO: to be implemented when the event will be triggered in 'DETAILS_PAGE'
});
